import { render, staticRenderFns } from "./BreedList.vue?vue&type=template&id=2dc14069&scoped=true&"
import script from "./BreedList.vue?vue&type=script&lang=js&"
export * from "./BreedList.vue?vue&type=script&lang=js&"
import style0 from "./BreedList.vue?vue&type=style&index=0&id=2dc14069&lang=scss&scoped=true&"
import style1 from "./BreedList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc14069",
  null
  
)

export default component.exports